import * as React from 'react';
import { SxProps, useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { PopperProps } from '@mui/material/Popper';

export const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}
  ></Tooltip> 
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500
  },
});

export const useImageTooltipClasses = () => {
  const theme = useTheme();

  const classes = {
    tooltip: {
      color: theme.palette.common.white,
      padding: "10px",
      marginBottom: "5px",
      marginTop: "10px",
      width: "auto",
      

      ".MuiTooltip-tooltip":{border: 0,}
    } as SxProps,

    text: {
      fontSize: 9,
      marginLeft: theme.spacing(4),
      textAlign: "left",
    } as SxProps,

   
  };
  return classes;
}